import { useState } from "react";

interface Props {
  values: number[];
  /** Подписи столбцов (даты), для подсказки и оси. */
  labels: string[];
  format: (v: number) => string;
}

const H = 100;
const PAD_TOP = 12;

/** Одна серия столбцов: по нажатию — значение дня, по умолчанию — максимум. */
export function BarChart({ values, labels, format }: Props) {
  const [active, setActive] = useState<number | null>(null);
  const max = Math.max(...values, 0) || 1;
  const n = Math.max(values.length, 1);
  const slot = 100 / n;
  const barW = Math.max(slot * 0.62, 0.8);
  const shown = active ?? values.reduce((best, v, i) => (v > (values[best] ?? -1) ? i : best), 0);

  return (
    <div className="daily">
      <div className="daily-tip" aria-live="polite">
        {values.length > 0 && (
          <>
            <b>{format(values[shown] ?? 0)}</b>
            <span> · {labels[shown]}</span>
          </>
        )}
      </div>
      <svg viewBox={`0 0 100 ${H}`} preserveAspectRatio="none" className="daily-svg" role="img" aria-label={values.map((v, i) => `${labels[i]}: ${format(v)}`).join(", ")}>
        {values.map((v, i) => {
          const h = v > 0 ? Math.max((v / max) * (H - PAD_TOP), 2) : 1;
          return (
            <g key={labels[i] ?? i} onClick={() => setActive(i)} onMouseEnter={() => setActive(i)}>
              <rect x={i * slot} y={0} width={slot} height={H} fill="transparent" />
              <rect
                x={i * slot + (slot - barW) / 2}
                y={H - h}
                width={barW}
                height={h}
                rx={Math.min(barW / 2, 1.2)}
                className={i === shown ? "daily-bar active" : v > 0 ? "daily-bar" : "daily-bar zero"}
              />
            </g>
          );
        })}
      </svg>
      <div className="daily-axis">
        <span>{labels[0]}</span>
        <span>{labels.at(-1)}</span>
      </div>
    </div>
  );
}
